/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from './env.config';
/**
 * EnvService handles all environment management.  It fetches the environment, provides methods
 * to extract data from the environment, and allows for temporary environment value setting.
 */
var SnEnvService = /** @class */ (function () {
    /**
     * @ignore
     */
    function SnEnvService(config, http) {
        this.config = config;
        this.http = http;
        this.envUrl = this.config.envUrl;
    }
    /**
     * Gets the entire environment or a single value of the environment
     * @param [key] key to get the value of
     * @returns if a `key` is given, returns the value of `key`.  else, returns
     * the entire environment
     */
    /**
     * Gets the entire environment or a single value of the environment
     * @param {?=} key
     * @return {?} if a `key` is given, returns the value of `key`.  else, returns
     * the entire environment
     */
    SnEnvService.prototype.get = /**
     * Gets the entire environment or a single value of the environment
     * @param {?=} key
     * @return {?} if a `key` is given, returns the value of `key`.  else, returns
     * the entire environment
     */
    function (key) {
        if (key) {
            return this.envJson[key];
        }
        return this.envJson;
    };
    /**
     * Sets properties in the environment
     * @param key key to set
     * @param value value to use for the given `key`
     */
    /**
     * Sets properties in the environment
     * @param {?} key key to set
     * @param {?} value value to use for the given `key`
     * @return {?}
     */
    SnEnvService.prototype.set = /**
     * Sets properties in the environment
     * @param {?} key key to set
     * @param {?} value value to use for the given `key`
     * @return {?}
     */
    function (key, value) {
        this.envJson[key] = value;
    };
    /**
     * Loads the environment JSON
     * @returns a promise that resolves with the environment
     */
    /**
     * Loads the environment JSON
     * @return {?} a promise that resolves with the environment
     */
    SnEnvService.prototype.bootstrap = /**
     * Loads the environment JSON
     * @return {?} a promise that resolves with the environment
     */
    function () {
        var _this = this;
        return this.http
            .get(this.envUrl)
            .toPromise()
            .then((/**
         * @param {?} envJson
         * @return {?}
         */
        function (envJson) {
            _this.envJson = envJson;
            return _this.envJson;
        }));
    };
    SnEnvService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SnEnvService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [CONFIG,] }] },
        { type: HttpClient }
    ]; };
    return SnEnvService;
}());
export { SnEnvService };
if (false) {
    /**
     * Path to fetch the environment JSON file
     * @ignore
     * @type {?}
     * @private
     */
    SnEnvService.prototype.envUrl;
    /**
     * Holds the environment
     * @ignore
     * @type {?}
     * @private
     */
    SnEnvService.prototype.envJson;
    /**
     * @type {?}
     * @private
     */
    SnEnvService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    SnEnvService.prototype.http;
}
//# sourceMappingURL=data:application/json;base64,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